import { useEffect, useState } from 'react';
import { ModalBase } from '../../components/ModalBase';
import { useAuth } from '../../context/AuthContext';
import { UpdateUsuarioDto, UsuarioResponseDto } from '../../interfaces/user';
import UsersService from '../../services/UsersService';

const GeneralData = () => {
    const { user, updateUser: updateAuthUser } = useAuth();
    const [form, setForm] = useState({
        nickname: '',
        fecha_nacimiento: '',
    });
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [success, setSuccess] = useState<UsuarioResponseDto | null>(null);
    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);


    // Cargar datos de usuario desde useAuth al montar
    useEffect(() => {
        if (user) {
            let birthdate = '';
            if (user.fecha_nacimiento) {
                const d = new Date(user.fecha_nacimiento);
                if (!isNaN(d.getTime())) {
                    birthdate = d.toISOString().slice(0, 10);
                }
            }
            const newForm = {
                nickname: user.nickname || '',
                fecha_nacimiento: birthdate,
                email: user.email || '',
            };
            setForm(newForm);
            // Validar todos los campos precargados
            Object.entries(newForm).forEach(([key, value]) => {
                validateField(key, value);
            });
        }
    }, [user]);



    const validateField = (field: string, value: any) => {
        let error = '';
        switch (field) {
            case 'nickname': {
                if (!value || value.length < 3) {
                    error = 'El Nombre o Nickname debe tener al menos 3 caracteres';
                } if (value && value.length > 20) {
                    error = 'El Nombre o Nickname debe tener máximo 20 caracteres';
                }
                else if (!/^[A-Za-zÁÉÍÓÚáéíóúÑñ0-9 ]+$/.test(value)) {
                    error = 'Solo letras, números y tildes son permitidos';
                }
                break;
            }
            case 'birthdate': {
                if (!value) {
                    error = 'La fecha de nacimiento es obligatoria';
                } else {
                    const date = new Date(value);
                    const now = new Date();
                    if (isNaN(date.getTime())) {
                        error = 'Fecha inválida';
                    } else if (date > now) {
                        error = 'La fecha no puede ser futura';
                    }
                }
                break;
            }
            // case 'email': {
            //     if (!value || !isValidEmailWithCommonTLD(value)) {
            //         error = 'Correo electrónico no válido';
            //     }
            //     break;
            // }
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: error }));
        return error === '';
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        let fieldValue: any;
        if (type === 'checkbox') {
            fieldValue = checked;
        } else {
            fieldValue = value.trim();
        }
        setForm(prev => ({ ...prev, [name]: fieldValue }));
        validateField(name, fieldValue);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        console.log('submit');
        e.preventDefault();
        try {
            setLoading(true);
            let valid = true;
            Object.entries(form).forEach(([key, value]) => {
                if (!validateField(key, value)) valid = false;
            });
            if (!valid) return;
            const requestData: UpdateUsuarioDto = {
                id_usuario: user!.id_usuario,
                email: user!.email,
                nickname: form.nickname,
                fecha_nacimiento: form.fecha_nacimiento,
            };
            const updatedData = await UsersService.updateUser(requestData);
            if (updatedData.statusCode === 200) {
                if (updatedData.usuario) {
                    updateAuthUser(updatedData.usuario);
                } else {
                    updateAuthUser({
                        nickname: form.nickname,
                        fecha_nacimiento: form.fecha_nacimiento,
                    });
                }
            }
            setSuccess(updatedData);
            setOpenModal(true);

        } catch (error) {

        } finally {
            setLoading(false);
        }
    };

    return (
        <div className=''>
            <h2>Editar Perfil de Usuario</h2>
            <form onSubmit={handleSubmit}>
                <div className='form-group'>
                    <label htmlFor='nickname'>Nombre o Nickname</label>
                    <input
                        className='input'
                        type='text'
                        id='nickname'
                        name='nickname'
                        value={form.nickname}
                        onChange={handleChange}
                        maxLength={21}
                    />
                    {errors.nickname && <div className='error-message'>{errors.nickname}</div>}
                </div>
                <div className='form-group'>
                    <label htmlFor='birthdate'>Fecha de Nacimiento</label>
                    <input
                        className='input'
                        type='date'
                        id='birthdate'
                        name='birthdate'
                        value={form.fecha_nacimiento}
                        onChange={handleChange}
                    />
                    {errors.birthdate && <div className='error-message'>{errors.birthdate}</div>}
                </div>
                {/* <div className='form-group'>
                    <label htmlFor='email'>Correo Electrónico</label>
                    <input
                        className='input'
                        type='email'
                        id='email'
                        name='email'
                        value={form.email}
                        onChange={handleChange}
                    />
                    {errors.email && <div className='error-message'>{errors.email}</div>}
                </div> */}
                {/* <div className='custom-checkbox-group'>
                    <label className='custom-checkbox-label' htmlFor='parental_consent'>
                        <input type='checkbox' id='parental_consent' name='parental_consent' required checked={form.parental_consent} onChange={handleChange} />
                        <span className='custom-checkbox'></span>
                        <span className='label-text'>
                            Consentimiento parental. He leído y acepto los
                            <a
                                href='/terminos'
                                target='_blank'
                                rel='noopener noreferrer'
                                className='parental_consent-link'
                                style={{ color: '#B57EDC', textDecoration: 'underline', marginLeft: 4 }}
                            >
                                Términos y condiciones
                            </a>
                        </span>
                    </label>
                    {errors.parental_consent && <div className='error-message'>{errors.parental_consent}</div>}
                </div> */}

                <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                    <button type='submit' className='btn btn-primary' disabled={loading}>
                        {loading ? 'Guardando...' : 'Guardar Cambios'}
                    </button>
                </div>
                {success && <div className='success-message'>{success.message}</div>}
            </form>
            <ModalBase
                isOpen={openModal}
                onRequestClose={() => setOpenModal(true)}
                title={success?.message || ''}
                type={success?.statusCode === 200 ? 'success' : 'error'}
                footerButtons={[
                    <button key='editar-perfil' className='btn btn-primary' onClick={() => setOpenModal(false)}>Ok</button>,
                ]}
            >
                <div>

                </div>
            </ModalBase>
        </div>
    );
};

export default GeneralData;